module.exports = __webpack_public_path__ + "ci.png?71b2c312f6429d84daf272db3a6be9b8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ci.png
// module id = 24
// module chunks = 0